import { render, staticRenderFns } from "./pafGeneration.vue?vue&type=template&id=bc7cd19a&"
import script from "./pafGeneration.vue?vue&type=script&lang=js&"
export * from "./pafGeneration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports